import { KeyboardEvent, useId, useRef, useState } from 'react'
import { Plus } from 'lucide-react'

type FaqItem = { question: string; answer: string }

export default function FaqList({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(null)
  const buttonRefs = useRef<Array<HTMLButtonElement | null>>([])
  const listId = useId().replaceAll(':', '')

  function handleKeyDown(event: KeyboardEvent<HTMLButtonElement>, index: number) {
    let nextIndex: number | undefined

    if (event.key === 'ArrowDown') nextIndex = (index + 1) % items.length
    if (event.key === 'ArrowUp') nextIndex = (index - 1 + items.length) % items.length
    if (event.key === 'Home') nextIndex = 0
    if (event.key === 'End') nextIndex = items.length - 1

    if (nextIndex !== undefined) {
      event.preventDefault()
      buttonRefs.current[nextIndex]?.focus()
    }
  }

  return (
    <div className="faq-list">
      {items.map((item, index) => {
        const isOpen = openIndex === index
        const buttonId = `${listId}-question-${index}`
        const panelId = `${listId}-answer-${index}`

        return (
          <div className="faq-item" key={item.question}>
            <h3>
              <button
                ref={(element) => { buttonRefs.current[index] = element }}
                id={buttonId}
                type="button"
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => setOpenIndex((current) => current === index ? null : index)}
                onKeyDown={(event) => handleKeyDown(event, index)}
              >
                <span>{item.question}</span>
                <Plus aria-hidden="true" />
              </button>
            </h3>
            <div
              className="faq-answer-shell"
              data-open={isOpen}
              id={panelId}
              role="region"
              aria-labelledby={buttonId}
              aria-hidden={!isOpen}
            >
              <div className="faq-answer"><p>{item.answer}</p></div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
